export default __webpack_public_path__ + "static/media/68.e5530ea7.jpg";